import React, { useCallback } from 'react';
import classNames from 'classnames';

import './RadioInput.scss';

type Props = {
  qaTest?: string;
  checked: boolean;
  className?: string;
  name?: string;
  label?: string | JSX.Element;
  onClick?: Function;
  value?: string | number;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
};

function RadioInput({
  qaTest,
  checked,
  name,
  onClick,
  label = '',
  className = '',
  value,
  onBlur,
  onFocus,
  disabled = false,
}: Props) {
  const handleRadioInputClick = useCallback(() => {
    if (!disabled && onClick) onClick(value);
  }, [value, onClick, disabled]);

  const classes = classNames(
    'workpatterns-radio-input',
    disabled ? 'workpatterns-radio-input--disabled' : false,
    className
  );

  return (
    <div data-test={qaTest} className={classes} onClick={handleRadioInputClick}>
      <input
        name={name}
        readOnly
        onBlur={onBlur}
        onFocus={onFocus}
        type="radio"
        checked={checked}
        disabled={disabled}
      />
      <label>{label}</label>
    </div>
  );
}

export default RadioInput;
